// removed by extract-text-webpack-plugin
module.exports = {"backgroundDark":"photoduneSearchSurveyBanner-module_backgroundDark_3EKES","surveyText":"photoduneSearchSurveyBanner-module_surveyText_2u3QT"};


//////////////////
// WEBPACK FOOTER
// ./client/components/banners/photoduneSearchSurveyBanner.module.css
// module id = 1016
// module chunks = 1